module.exports = __webpack_public_path__ + "static/media/hp.e0e109d0.png";